<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'currentColor',
  },
  size: {
    type: String,
    default: '24',
  },
  customClass: {
    type: String,
    default: '',
  },
  title: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <svg :class="customClass" :height="props.size" :width="props.size" role="presentation">
    <title v-if="props.title" :id="props.name" lang="en">{{ props.name }} icon</title>
    <use :href="`#${props.name}`" :fill="props.color" />
  </svg>
</template>
